// Because of JS import hoisting, we need this init code to be here,
// so that following imports in application.js have access to `jQuery` and `$`

import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
